// extracted by mini-css-extract-plugin
module.exports = {"header":"Header_header__1v0yI","headerLogoImage":"Header_headerLogoImage__3QD7C","profile":"Header_profile__yHIKp","logout":"Header_logout__28K7C","docs":"Header_docs__3VWoJ"};